import { render } from "./SubBucketHat_1_front.vue?vue&type=template&id=3afc5e8f"
import script from "./SubBucketHat_1_front.vue?vue&type=script&lang=js"
export * from "./SubBucketHat_1_front.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__